import { SyndicationDomainIdSchema as n, ReviewStatusSchema as t } from "@hprofits/shared";
import { z as i } from "zod";
import { PaginationSchema as o, paginatedList as a } from "../common/pagination.js";
const r = i.object({
  syndicationDomainId: i.coerce.number().pipe(n)
}), d = o.extend({
  search: i.string().trim().min(1).optional()
}).readonly(), e = i.object({
  id: n,
  domain: i.string(),
  description: i.string(),
  status: t,
  cdnHost: i.string(),
  staticHost: i.string(),
  createdAt: i.string()
}).readonly(), S = a(e);
export {
  r as SyndicationDomainIdParamSchema,
  e as SyndicationDomainSchema,
  d as SyndicationDomainsQuerySchema,
  S as SyndicationDomainsResponseSchema
};
//# sourceMappingURL=schemas.js.map
